import { modalRenderer } from '~/modal/modalRendererRegistry';
import {
  ExportBoundaryTerritoryContainer, type ExportBoundaryTerritoryContainerProps,
} from './exportBoundaryTerritory.container';

declare module '~/modal/modalRegistry.type' {
  interface ModalComponentRegistry {
    ExportTerritoryData: ExportBoundaryTerritoryContainerProps;
  }
}
modalRenderer.register('ExportTerritoryData', ExportBoundaryTerritoryContainer);
